import React from 'react';
import PropTypes from 'prop-types';
import { ValidatedTextInputV2 } from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';
import { EditPageTitle, EditPageActions } from 'src/components';
import { nonEmptyValidator } from 'src/validators';
import { PLATE_NAME } from 'src/constants/forms';

import { PlateDisplay } from './components';

import messages from './messages';

const EditPlateComponent = ({
  onCancel,
  onSubmit,
  canSubmit,
  formState,
  onChangeField,
  onBackClick,
  wells,
  onWellClick,
  plateSize,
  enableActionButtons
}) => (
  <>
    <EditPageTitle
      title={messages.editPlateTitle}
      backButtonLabel={messages.editPlateBackButtonLabel}
      onBackClick={onBackClick}
    />
    <ValidatedTextInputV2
      data-testid="primer-name-input"
      label={<Message message={messages.plateName} />}
      required
      showOnlyOneError
      value={formState[PLATE_NAME]?.value}
      onChange={(value, e, canValidate, isValid) => onChangeField(value, PLATE_NAME, isValid)}
      validators={[nonEmptyValidator(messages.plateNameRequired)]}
      initialValidation={!!formState[PLATE_NAME]?.value}
    />
    <PlateDisplay plateSize={plateSize} wells={wells} onWellClick={onWellClick} />
    <EditPageActions
      {...{
        onCancel,
        onSubmit,
        canSubmit,
        enableActionButtons
      }}
    />
  </>
);

EditPlateComponent.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  canSubmit: PropTypes.bool.isRequired,
  formState: PropTypes.object,
  onChangeField: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  wells: PropTypes.array,
  onWellClick: PropTypes.func.isRequired,
  plateSize: PropTypes.number,
  enableActionButtons: PropTypes.bool
};

export default EditPlateComponent;
